import Vue from "vue";
import GlobalDealerSearch from "@global/global-elements/global-dealer-search/global-dealer-search";
import Vuex from 'vuex';
import VueI18n from 'vue-i18n';

import gdsStates from "@global/global-elements/global-dealer-search/store/states";
import gdsMutations from "@global/global-elements/global-dealer-search/store/mutations";
import gdsGetters from "@global/global-elements/global-dealer-search/store/getters";
import gdsActions from "@global/global-elements/global-dealer-search/store/actions";

export const dealersearch = {
    init: () => {
        const dealerSearchShell = document.getElementById('dealer-search');
        Vue.use(Vuex);
        Vue.use(VueI18n);

        // eslint-disable-next-line import/no-named-as-default-member
        const store = new Vuex.Store({
            state: gdsStates,
            mutations: gdsMutations,
            getters: gdsGetters,
            actions: gdsActions
        });

        new Vue({
            render: h => h(GlobalDealerSearch),
            i18n: new VueI18n({
                locale: 'dealersearch', // set locale
                messages: window.DEALER_SEARCH_I18N // set locale messages
            }),
            store
        }).$mount(dealerSearchShell);
    }
};
